<template>
  <Header></Header>
  <el-alert
    title="已绑定手机号的用户，请通过此页面重新找回密码。尚未绑定手机号的用户，请联系授课老师或管理员为您重置密码。"
    type="warning"
    center
    show-icon
    v-show="passwordType == 1"
  />
  <el-alert
    title="已设置安全问题的用户，可以通过回答安全问题新找回密码。尚未设置安全问题，请联系授课老师或管理员为您重置密码。"
    type="warning"
    center
    show-icon
    v-show="passwordType == 2"
  />
  <el-card class="box-card">
    <template #header>
      <div class="card-header">
        <el-tabs
          v-model="passwordType"
          class="demo-tabs"
          @tab-click="handleClick"
        >
          <el-tab-pane label="手机验证找回" name="1"></el-tab-pane>
          <el-tab-pane label="安全问题找回" name="2"></el-tab-pane>
        </el-tabs>
      </div>
    </template>
    <!-- 手机验证找回 -->
    <el-form
      ref="fFormRef"
      :model="fForm"
      :rules="fRules"
      label-width="100px"
      v-show="passwordType == 1"
    >
      <el-form-item label="手机号" prop="tel">
        <el-input v-model="fForm.tel" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item class="warnigBig" label="新密码" prop="newPassword">
        <el-input
          v-model="fForm.newPassword"
          :type="showPassword ? 'text' : 'password'"
          placeholder="8-32位，含大小写字母、数字或特殊符号的其中两项"
        />
        <div class="eye-p">
          <img
            v-show="showPassword"
            src="@/assets/image/eye.png"
            @click="showPassword = false"
          />
          <img
            v-show="!showPassword"
            src="@/assets/image/closeEye.png"
            @click="showPassword = true"
          />
        </div>
      </el-form-item>
      <el-form-item label="确认密码" prop="rePassword">
        <el-input
          v-model="fForm.rePassword"
          :type="showPassword2 ? 'text' : 'password'"
          placeholder="需和上次输入一致"
        />
        <div class="eye-p">
          <img
            v-show="showPassword2"
            src="@/assets/image/eye.png"
            @click="showPassword2 = false"
          />
          <img
            v-show="!showPassword2"
            src="@/assets/image/closeEye.png"
            @click="showPassword2 = true"
          />
        </div>
      </el-form-item>
      <el-form-item label="验证码" prop="sms">
        <el-row :gutter="20">
          <el-col :span="18" :xs="14">
            <el-input
              v-model="fForm.sms"
              placeholder="请输入验证码"
              @blur="verifyCode(fForm.tel, fForm.sms, 'forgetPassword')"
            />
          </el-col>
          <el-col v-show="sendBtnShow" :span="6" :xs="4">
            <el-button
              @click="
                sendVerify(fForm.tel, 'forgetPassword');
                setTime();
              "
              >发送验证码</el-button
            >
          </el-col>
          <el-col v-show="!sendBtnShow" :span="6">
            <el-button>重新发送({{ counter }}s)</el-button>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item class="mobileAgreement">
        <el-checkbox
          v-model="customCheck"
          type="checkbox"
          class="custom-control-input"
          id="customCheck"
          style="margin-right: 10px"
        />
        <label class="custom-control-label" for="customCheck"
          >我已阅读并同意<router-link target="_blank" to="/agreement"
            >《外研教学评用户协议》</router-link
          >
          <router-link target="_blank" to="/privacy"
            >《外研教学评隐私政策》</router-link
          ></label
        >
      </el-form-item>
      <el-form-item class="mobile-btn">
        <el-button class="largeBtn" type="primary" @click="resetPassword()"
          >确认修改</el-button
        >
      </el-form-item>
    </el-form>
    <!-- 安全问题找回 -->
    <el-form
      ref="qFormRef"
      :rules="qRules"
      :model="qForm"
      label-width="100px"
      v-show="passwordType == 2"
    >
      <el-form-item label="用户名" prop="userName">
        <el-input
          v-model="qForm.userName"
          placeholder="请输入用户名"
        ></el-input>
      </el-form-item>
      <el-form-item label="问题" prop="answer">
        <el-select v-model="qForm.question" placeholder="请选择问题">
          <el-option
            label="请输入您的出生年月日（如：1900101）"
            value="请输入您的出生年月日（如：1900101）"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="答案" prop="answer">
        <el-input
          v-model="qForm.answer"
          placeholder="请输入问题答案"
        ></el-input>
      </el-form-item>
      <el-form-item class="warnigBig" label="新密码" prop="newPassword">
        <el-input
          v-model="qForm.newPassword"
          :type="showPassword ? 'text' : 'password'"
          placeholder="8-32位，含大小写字母、数字或特殊符号的其中两项"
        />
        <div class="eye-p">
          <img
            v-show="showPassword"
            src="@/assets/image/eye.png"
            @click="showPassword = false"
          />
          <img
            v-show="!showPassword"
            src="@/assets/image/closeEye.png"
            @click="showPassword = true"
          />
        </div>
      </el-form-item>
      <el-form-item label="确认密码" prop="rePassword">
        <el-input
          v-model="qForm.rePassword"
          :type="showPassword2 ? 'text' : 'password'"
          placeholder="需和上次输入一致"
        />
        <div class="eye-p">
          <img
            v-show="showPassword2"
            src="@/assets/image/eye.png"
            @click="showPassword2 = false"
          />
          <img
            v-show="!showPassword2"
            src="@/assets/image/closeEye.png"
            @click="showPassword2 = true"
          />
        </div>
      </el-form-item>

      <el-form-item class="mobileAgreement">
        <el-checkbox
          v-model="customCheck"
          type="checkbox"
          class="custom-control-input"
          id="customCheck"
          style="margin-right: 10px"
        />
        <label class="custom-control-label" for="customCheck"
          >我已阅读并同意<router-link target="_blank" to="/agreement"
            >《外研教学评用户协议》</router-link
          >
          <router-link target="_blank" to="/privacy"
            >《外研教学评隐私政策》</router-link
          ></label
        >
      </el-form-item>
      <el-form-item class="mobile-btn">
        <el-button class="largeBtn" type="primary" @click="resetqaPassword()"
          >确认修改</el-button
        >
      </el-form-item>
    </el-form>
    <div class="clearFloat">
      <div class="floatR">
        <router-link to="/login">登录系统</router-link>
      </div>
    </div>
  </el-card>
</template>
<script>
import Header from "@/components/Header.vue";
import { sendVerify, verifyCode } from "@/utils/utils.js";
import { ref, toRefs, reactive, getCurrentInstance } from "vue";
import { toResetPassword, toResetPasswordByQA, AutoLogin } from "@/api/api.js";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import { localStore, moduleInfos } from "@/utils/utils.js";

import {
  validatePassword,
  validateTel,
  validateNull,
  validateAns,
  validateQus,
} from "@/utils/validate.js";
import { validateUsername } from "../utils/validate";
export default {
  components: { Header },
  setup() {
    const { proxy } = getCurrentInstance(); // 使用proxy代替ctx，因为ctx只在开发环境有效
    const router = useRouter();
    const state = reactive({
      fForm: {
        tel: "",
        newPassword: "",
        rePassword: "",
        sms: "",
      },
      qForm: {
        userName: "",
        question: "",
        answer: "",
        newPassword: "",
        rePassword: "",
      },
      fFormRef: null,
      qFormRef: null,
      customCheck: false,
      sendBtnShow: true,
      counter: 60,
      showPassword: false,
      showPassword2: false,
    });
    let passwordType = ref("1");
    const validateRePassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("密码不能为空"));
      } else {
        if (value !== state.fForm.newPassword) {
          callback(new Error("两次密码输入不一致！"));
        }
        callback();
      }
    };
    const validateRePasswordqa = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("密码不能为空"));
      } else {
        if (value !== state.qForm.newPassword) {
          callback(new Error("两次密码输入不一致！"));
        }
        callback();
      }
    };
    const fRules = {
      tel: [{ validator: validateTel, trigger: "blur" }],
      sms: [{ validator: validateNull, trigger: "blur" }],
      newPassword: [{ validator: validatePassword, trigger: "blur" }],
      rePassword: [{ validator: validateRePassword, trigger: "blur" }],
    };
    const qRules = {
      userName: [{ validator: validateUsername, trigger: "blur" }],
      answer: [{ validator: validateAns, trigger: "blur" }],
      question: [{ validator: validateQus, trigger: "blur" }],
      newPassword: [{ validator: validatePassword, trigger: "blur" }],
      rePassword: [{ validator: validateRePasswordqa, trigger: "blur" }],
    };
    const resetPassword = () => {
      state.fFormRef.validate((valide) => {
        if (valide) {
          if (state.customCheck) {
            toResetPassword({
              newPassword: proxy.$encryption(state.fForm.newPassword),
              mobile: state.fForm.tel,
              code: state.fForm.sms,
            }).then((response) => {
              if (response["status"] == 0) {
                localStore("autoToken", response["data"]["accessToken"]);
                localStore("tokenType", response["data"]["tokenType"]);
                localStore(
                  "autoUser",
                  JSON.stringify(response["data"]["additionalInformation"])
                );
                if (response["data"]["additionalInformation"].userRole == 1) {
                  ElMessage({
                    message: "修改密码成功，请重新登录",
                    type: "success",
                  });
                  setTimeout(() => router.push("/login"), 3000);
                  return 0;
                }
                AutoLogin().then((response) => {
                  var rolesArr =
                    response["data"]["additionalInformation"]["userAppRoles"];
                  for (var i = 0; i < rolesArr.length; i++) {
                    var moduleInfo = moduleInfos[rolesArr[i].appCode];
                    if (moduleInfo) {
                      rolesArr[i].url = moduleInfo["url"];
                      rolesArr[i].img = "image/" + moduleInfo["logo"];
                    }
                  }
                  localStore("token", response["data"]["accessToken"]);
                  localStore("tokenType", response["data"]["tokenType"]);
                  localStore("refreshToken", response["data"]["refreshToken"]);
                  localStore(
                    "isExpiredPass",
                    response["data"]["additionalInformation"]["isExpiredPass"]
                  );
                  localStore(
                    "loginId",
                    response["data"]["additionalInformation"].userName
                  );
                  dealLogin(response["data"], state.yjChannelId);
                });
              } else {
                ElMessage({
                  message: response["msg"],
                  type: "warning",
                });
              }
            });
          } else {
            ElMessage({
              message: "请阅读并选中协议～",
              type: "warning",
            });
          }
        }
      });
    };
    const resetqaPassword = () => {
      state.qFormRef.validate((valide) => {
        if (valide) {
          if (state.customCheck) {
            toResetPasswordByQA({
              userName: state.qForm.userName,
              question: state.qForm.question,
              answer: state.qForm.answer,
              newPassword: proxy.$encryption(state.qForm.newPassword),
            }).then((response) => {
              if (response["status"] == 0) {
                localStore("autoToken", response["data"]["accessToken"]);
                localStore("tokenType", response["data"]["tokenType"]);
                localStore(
                  "autoUser",
                  JSON.stringify(response["data"]["additionalInformation"])
                );
                if (response["data"]["additionalInformation"].userRole == 1) {
                  ElMessage({
                    message: "修改密码成功，请重新登录",
                    type: "success",
                  });
                  setTimeout(() => router.push("/login"), 3000);
                  return 0;
                }
                AutoLogin().then((response) => {
                  var rolesArr =
                    response["data"]["additionalInformation"]["userAppRoles"];
                  for (var i = 0; i < rolesArr.length; i++) {
                    var moduleInfo = moduleInfos[rolesArr[i].appCode];
                    if (moduleInfo) {
                      rolesArr[i].url = moduleInfo["url"];
                      rolesArr[i].img = "image/" + moduleInfo["logo"];
                    }
                  }
                  localStore("token", response["data"]["accessToken"]);
                  localStore("tokenType", response["data"]["tokenType"]);
                  localStore("refreshToken", response["data"]["refreshToken"]);
                  localStore(
                    "isExpiredPass",
                    response["data"]["additionalInformation"]["isExpiredPass"]
                  );
                  localStore(
                    "loginId",
                    response["data"]["additionalInformation"].userName
                  );
                  dealLogin(response["data"], state.yjChannelId);
                });
              } else {
                ElMessage({
                  message: response["msg"],
                  type: "warning",
                });
              }
            });
          } else {
            ElMessage({
              message: "请阅读并选中协议～",
              type: "warning",
            });
          }
        }
      });
    };
    const dealLogin = (data, yjChannelId) => {
      let addData = data["additionalInformation"];
      localStore("userId", addData["userId"]);
      localStore("userName", addData["userName"]);
      localStore("userRole", addData["userRole"]);
      localStore("userOrganizes", JSON.stringify(addData["userOrganizes"]));
      localStore("fullName", addData["fullName"]);
      localStore("portrait", addData["portrait"]);
      localStore("registerType", addData["registerType"]);
      localStore("userAppRoles", JSON.stringify(addData["userAppRoles"]));
      localStore("channelId", yjChannelId);
      localStore("mobile", addData["mobile"]);
      // 带有悦测评重定向的地址
      if (router.currentRoute.value.query.redirect_url) {
        window.location.href = decodeURIComponent(
          router.currentRoute.value.query.redirect_url
        );
        return;
      }
      // 带有悦教大讲堂重定向的地址
      if (yjChannelId) {
        if (yjChannelId == "fjyd") {
          window.location.href = "yuejiao/route.html?channel=fjyd";
          return;
        }
      }
      if (addData["defaultPass"] || addData["changePass"]) {
        //需要修改密码的情况
        ElMessage({
          message: "请修改密码,即将跳转修改密码页.......",
          type: "warning",
        });
        setTimeout(
          () =>
            router.push({
              path: "/setUserInfo",
              query: {
                changePwd: true,
              },
            }),
          3000
        );
      } else {
        //不需要修改密码的情况
        var haveAuthArr = [];
        var log_id = localStore("loginId");
        let info = JSON.parse(localStore("userAppRoles"));
        if (log_id && (info.length != 0 || addData["userRole"] != 4)) {
          // 有路径跳转地址时
          var redirectUrl = getRedirect();
          if (redirectUrl) {
            clearRedirect();
            window.location.href = redirectUrl;
          } else if (state.hrefCode && state.hrefUrl) {
            info.forEach(function (item) {
              haveAuthArr.push(item.appCode);
            });
            if (haveAuthArr.indexOf(state.hrefCode) !== -1) {
              window.location.href = state.hrefUrl;
            } else {
              // 无权限，跳转至新页面
              router.push({
                path: "/noAuth",
                query: {
                  appCode: state.hrefCode,
                },
              });
            }
            if (window.opener != null) {
              var isIndex = window.opener.location.pathname.substring(
                window.opener.location.pathname.lastIndexOf("/")
              );
              if (isIndex == "/login") {
                //如果父页面是login或者为空则不刷新页面
              } else {
                window.opener.location.reload(true);
              }
            }
          } else {
            router.push("/myApp");
          }
        } else {
          ElMessage({
            message: "您没有任何子系统的权限",
            type: "warning",
          });
          router.push("/myApp");
        }
      }
    };
    const clearRedirect = () => {
      window.sessionStorage.removeItem(state.keyRedirect);
    };
    const getRedirect = () => {
      return window.sessionStorage.getItem(state.keyRedirect);
    };
    const setTime = () => {
      var timer;
      if (state.sendBtnShow) {
        state.sendBtnShow = false;
        timer = setInterval(() => {
          if (state.counter > 0 && state.counter <= 60) {
            state.counter--;
          } else {
            state.sendBtnShow = true;
            state.counter = 60;
            clearInterval(timer);
          }
        }, 1000);
      }
    };
    return {
      ...toRefs(state),
      resetPassword,
      sendVerify,
      verifyCode,
      fRules,
      qRules,
      setTime,
      passwordType,
      resetqaPassword,
    };
  },
};
</script>

<style lang="scss" scoped>
.card-header {
  border: none;
  display: flex;
  justify-content: center;
}
</style>

<style lang="scss">
.box-card {
  .el-card__header {
    border: none;
  }
  .el-card__header {
    padding-bottom: 0;
  }
}
</style>
